// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3o-1";
export var rateTableServiceLevelDropdown = "_3o-3";
export var rateTableTypeDropdown = "_3o-0";
export var rateTableValueModeDropdown = "_3o-2";